
import { Component, Vue } from 'vue-property-decorator';

import Form18ProcessHeader from "@/components/process/Form18/components/Form18ProcessHeader.vue";
import Form18StyleOfProceeding from "@/components/process/Form18/components/Form18StyleOfProceeding.vue";
import { form18StatusInfoType } from '@/types/Information/Form18';

@Component({
    components:{
        Form18ProcessHeader,        
        Form18StyleOfProceeding
    }
})
export default class FillForm18 extends Vue {

    stepsCompleted = {} as form18StatusInfoType;   

    mounted() {  
        this.stepsCompleted = {
            first: false,
            second: false,
            third: false
        }       
    }
}
